<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<template>
  <div>
    <vx-card v-if="step == Step.Save" class="mb-3">
      <div class="sm:w-1/2 w-full">
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="عنوان"
              v-model="title"
            />
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="شرح"
              v-model="description"
            />
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full flex">
            <vs-button
              class="mr-3 mb-2"
              @click="goToEditItemsStep"
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-arrow-right-circle"
              >قبلی</vs-button
            >
            <vs-button
              class="mb-2"
              @click="save"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-send"
            >
              ارسال قبوض
            </vs-button>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card v-if="step == Step.EditItems">
      <!-- pagination :max-items="100" -->
      <div class="vx-row">
        <div class="vx-col">
          <a class="mb-2 block underline" href="/BillGroup Sample.xlsx"
            >فایل اکسل نمونه</a
          >
        </div>
      </div>
      <div class="vx-row bills-chart-nav">
        <div class="vx-col w-full">
          <vs-table
            id="tbl1"
            ref="tbl1"
            pagination
            :max-items="paginationPageSize"
            stripe
            :data="tableData"
            w-full
          >
            <template slot="header">
              <div class="vx-row mb-2 w-full">
                <div class="vx-col">
                  <vs-button
                    @click="importExel"
                    class="p-2"
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-upload-cloud"
                  >
                    آپلود اکسل
                  </vs-button>
                </div>
                <div class="vx-col">
                  <vs-button
                    class="px-2 py-2"
                    @click="addItem"
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-plus-circle"
                    >افزودن گیرنده قبض</vs-button
                  >
                </div>
                <div
                  class="vx-col"
                  style="
                    opacity: 0.9;
                    transform: scale(1, 1.5);
                    line-height: 2.8rem;
                  "
                >
                  |
                </div>
                <div class="vx-col flex">
                  <vs-input
                    inputmode="numeric"
                    class="rtl mr-1"
                    icon-after
                    v-model="sourceAmount"
                    @keyup="amountKeyUp($event)"
                    style="width: 11.2rem"
                    placeholder="تنظیم مبلغ برای همه"
                  />
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-check"
                    title="تنظیم مبلغ برای همه"
                    @click="editAmount"
                  ></vs-button>
                </div>
                <div class="vx-col">
                  مجموع:
                  {{ totalAmount }}
                </div>
                <div class="vx-col" style="margin-right: auto">
                  <vs-button
                    @click="clean"
                    class="px-2 py-2"
                    color="danger"
                    type="border"
                    icon-pack="feather"
                    icon="icon-trash"
                    >حذف همه</vs-button
                  >
                </div>
              </div>

              <!-- <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span
                class="mr-2">{{ $refs.tbl1 == undefined ? 1 : ($refs.tbl1.currentx* paginationPageSize - (paginationPageSize - 1)) }}
                -
                {{ tableData.length - ($refs.tbl1 == undefined ? 1 : $refs.tbl1.currentx) * paginationPageSize > 0 ? ($refs.tbl1 == undefined ? 1 : $refs.tbl1.currentx) * paginationPageSize : tableData.length }}
                از {{ tableData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="SetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="SetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="SetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="SetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="SetPageSize(150)">
                <span>150</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
              </div>-->
            </template>

            <template slot="thead">
              <vs-th>ردیف</vs-th>
              <vs-th sort-key="mobile" key="mobile">تلفن همراه</vs-th>
              <vs-th key="amount">مبلغ</vs-th>
              <vs-th sort-key="name" key="name">نام و نام خانوادگی</vs-th>
              <vs-th
                :data="item"
                :key="i"
                v-for="(item, i) in descriptionHeaders"
                >{{ item }}</vs-th
              >
              <vs-th>حذف</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
                v-bind:class="{ 'is-blocked': tr.isBlocked }"
              >
                <vs-td>{{
                  paginationPageSize * ($refs.tbl1.currentx - 1) + indextr + 1
                }}</vs-td>
                <vs-td :data="data[indextr].mobile">
                  <vs-input
                    inputmode="numeric"
                    size="small"
                    v-model="data[indextr].mobile"
                    style="direction: ltr"
                    @keyup="mobileKeyUp($event)"
                    placeholder="09120000000"
                  />
                </vs-td>
                <vs-td :data="data[indextr].amount">
                  <div class="inline-flex">
                    <vs-input
                      inputmode="numeric"
                      size="small"
                      class="w-full ltr-input"
                      name="amount"
                      v-model="data[indextr].amount"
                      @keyup="amountKeyUp($event, indextr)"
                    />
                    <span class="pt-2 pl-1">ریال</span>
                  </div>
                </vs-td>
                <vs-td>
                  <vs-input size="small" v-model="data[indextr].name" />
                </vs-td>
                <vs-td
                  :data="item"
                  :key="i"
                  v-for="(item, i) in descriptionHeaders"
                >
                  <vs-input size="small" v-model="data[indextr][item]" />
                </vs-td>
                <vs-td>
                  <feather-icon
                    @click="
                      removeItem(
                        paginationPageSize * ($refs.tbl1.currentx - 1) + indextr
                      )
                    "
                    icon="XIcon"
                    svgClasses="stroke-current text-danger"
                  />
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td colspan="6" style="text-align: center">
                  <div
                    class="w-full"
                    style="text-align: center; cursor: pointer"
                  >
                    <vs-button
                      @click="addItem"
                      type="flat"
                      icon-pack="feather"
                      icon="icon-plus"
                      color="dark"
                      style="margin: 0 auto"
                      >افزودن گیرنده قبض</vs-button
                    >
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            @click="goToSaveStep"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-arrow-left-circle"
            >بعدی</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card v-if="step == Step.Saved">
      <!-- pagination :max-items="100" -->
      <vs-table
        id="tbl2"
        ref="tbl2"
        pagination
        :max-items="paginationPageSize"
        stripe
        search
        :data="allowedList"
      >
        <template slot="header">
          <vs-button
            @click="refreshPage"
            class="mx-3"
            color="danger"
            type="border"
            icon-pack="feather"
            icon="icon-corner-up-right"
            >برگشت</vs-button
          >

          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">
                  {{
                    $refs.tbl2 == undefined
                      ? 1
                      : $refs.tbl2.currentx * paginationPageSize -
                        (paginationPageSize - 1)
                  }}
                  -
                  {{
                    tableData.length -
                      ($refs.tbl2 == undefined ? 1 : $refs.tbl2.currentx) *
                        paginationPageSize >
                    0
                      ? ($refs.tbl2 == undefined ? 1 : $refs.tbl2.currentx) *
                        paginationPageSize
                      : tableData.length
                  }}
                  از {{ tableData.length }}
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="SetPageSize(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="SetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="SetPageSize(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="SetPageSize(100)">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="SetPageSize(150)">
                  <span>150</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </template>

        <template slot="thead">
          <vs-th>ردیف</vs-th>
          <vs-th sort-key="mobile" key="mobile">تلفن همراه</vs-th>
          <vs-th sort-key="amount" key="amount">مبلغ</vs-th>
          <vs-th sort-key="name" key="name">نام و نام خانوادگی</vs-th>
          <vs-th
            :data="item"
            :key="i"
            v-for="(item, i) in descriptionHeaders"
            >{{ item }}</vs-th
          >
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{
              paginationPageSize * ($refs.tbl2.currentx - 1) + indextr + 1
            }}</vs-td>
            <vs-td style="direction: ltr; text-align: right">{{
              formatMobile(data[indextr].mobile)
            }}</vs-td>
            <vs-td>{{ formatAmount(data[indextr].amount) }} ريال</vs-td>
            <vs-td>{{ data[indextr].contactName }}</vs-td>
            <vs-td
              :data="item"
              :key="i"
              v-for="(item, i) in descriptionHeaders"
              >{{ JSON.parse(data[indextr].merchantDescription)[item] }}</vs-td
            >
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <bill-bull-upload-excel
      ref="BillBulkUploadExcel1"
      @loadData="loadDataInTable"
    ></bill-bull-upload-excel>
  </div>
</template>
<style>
.remove-nav {
  background: #ea5455;
  color: #eee;
}
.excel-import div,
.remove-nav {
  padding-top: 0 !important;
  padding-bottom: 17px !important;
}
.excel-import div span,
.remove-nav span {
  display: inline-block !important;
  bottom: -1em;
  margin-left: 1em;
}
.is-blocked {
  border-width: 0;
  border-left-width: 6px;
  border-right-width: 6px;
  border-style: dashed;
  border-color: red;
}
.bills-chart-nav td,
.bills-chart-nav th {
  padding: 10px 5px !important;
}
.bills-chart-nav table td .vs-input {
  min-width: 80px;
  width: auto;
}
</style>
<script>
import BillBulkUploadExcel from "./BillBulkUploadExcel.vue";
const Step = Object.freeze({ EditItems: 1, Save: 2, Saved: 3 });
export default {
  components: {
    "bill-bull-upload-excel": BillBulkUploadExcel,
  },
  data() {
    return {
      tableData: [],
      allowedList: [],
      paginationPageSize: 10,
      Step,
      step: Step.EditItems,
      title: "",
      description: "",
      checkedAllowedListFromServer: false,
      sourceAmount: "",
      descriptionHeaders: ["توضیحات"],
    };
  },
  watch: {
    tableData: {
      handler: function () {
        this.checkedAllowedListFromServer = false;
      },
      deep: true,
    },
  },
  computed: {
    totalAmount() {
      if (
        this.tableData == null ||
        this.tableData == undefined ||
        this.tableData.length == 0
      )
        return 0;
      let total = 0;
      this.tableData.forEach((item) => {
        let amount = parseInt(item.amount.replace(/,/g, ""));
        total += isNaN(amount) ? 0 : amount;
      });
      return this.formatAmount(total);
    },
  },
  methods: {
    importExel() {
      if (this.tableData.length > 0)
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: `اخطار`,
          cancelText: `انصراف`,
          acceptText: `باشه`,
          text: `آپلود فایل جدید باعث پاک شدن داده های فعلی می شود.

          آیا مطمئنید؟`,
          accept: this.$refs.BillBulkUploadExcel1.browseFile,
        });
      else this.$refs.BillBulkUploadExcel1.browseFile();
    },
    async loadDataInTable(validBills, descriptionHeaders) {
      //if (errorCount == 0) {
      this.tableData = validBills;
      this.descriptionHeaders = descriptionHeaders;
      //}
    },
    addItem() {
      let newRow = {
        mobile: "",
        amount: "",
        name: "",
      };
      for (let i = 0; i < this.descriptionHeaders.length; i++) {
        const x = this.descriptionHeaders[i];
        newRow[x] = "";
      }
      this.tableData.unshift(newRow);
    },
    removeItem(i) {
      this.tableData.splice(i, 1);
    },
    clean() {
      this.descriptionHeaders = ["توضیحات"];
      this.tableData = [];
    },
    SetPageSize(size) {
      this.paginationPageSize = size;
    },
    validateAmount(val) {
      val = val.toString().replace(/,/g, "");
      return /^[1-9]\d*$/.test(val);
    },
    formatAmount(val) {
      if (val.length > 11) val = val.slice(0, 11);
      val = val.toString().replace(/,/g, "");
      if (isNaN(parseInt(val))) return val;
      else return parseInt(val).toLocaleString();
    },
    amountKeyUp(event, i) {
      event.target.value = this.formatAmount(event.target.value);
      if (i != undefined)
        this.tableData[i].amount = this.formatAmount(event.target.value);
      else {
        if (event.key == "Enter") this.editAmount();
        this.sourceAmount = this.formatAmount(event.target.value);
      }
    },
    validateMobile(val) {
      val = val.toString().replace(/ /g, "");
      return /^(\+98|0|98|0098)?9\d{9}$/.test(val);
    },
    formatMobile(val) {
      val = val.toString().replace(/ /g, "");
      var result = val;
      if (val.length > 4) {
        result = val.slice(0, 4) + "  " + val.slice(4, 7);
        if (val.length > 7) result += "  " + val.slice(7, 11);
      }
      return result;
    },
    mobileKeyUp(event) {
      event.target.value = this.formatMobile(event.target.value);
    },
    async goToSaveStep() {
      const selectedAccount = this.$store.getters["account/default"];
      if (!selectedAccount) {
        this.$helper.selectAccount();
        return;
      }
      const headers = {
        AccountId: selectedAccount.id,
      };
      if (this.checkAllowedListFromServer) {
        this.step = this.Step.Save;
        return;
      }
      if (this.tableData.length == 0) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "لیست قبوض خالی است",
          text: `لطفا یک قبض وارد کنید`,
        });
        return;
      }
      let loading = this.$vs.loading();
      try {
        let errorCount = 0;
        let mobileList = [];
        //begin validate data ----------------------
        for (let i = 0; i < this.tableData.length; i++) {
          let row = {};
          row.amount = this.tableData[i].amount.replace(/,/g, "");
          row.mobile = this.tableData[i].mobile.replace(/ /g, "");

          if (!this.validateMobile(row.mobile)) {
            errorCount += 1;

            this.$Sentry.captureException(
              "مبلغ نامعتبر" +
                " row.mobile=" +
                row.mobile.toString() +
                " this.validateMobile(row.mobile)=" +
                this.validateMobile(row.mobile).toString()
            );

            this.$vs.notify({
              time: 4000 + errorCount * 300,
              color: "danger",
              title: "شماره همراه اشتباه",
              text: `تلفن همراه ردیف ${i + 1} صحیح نمی باشد.`,
            });
          }

          if (
            this.tableData.filter((x) => x.mobile == this.tableData[i].mobile)
              .length > 1
          ) {
            errorCount += 1;
            this.$vs.notify({
              time: 4000 + errorCount * 400,
              color: "danger",
              title: "شماره همراه تکراری",
              text: `تلفن همراه ردیف ${i + 1} تکراری است.`,
            });
          }

          if (isNaN(row.amount) || !this.validateAmount(row.amount)) {
            errorCount += 1;

            this.$Sentry.captureException(
              "مبلغ نامعتبر" +
                " row.amount=" +
                row.amount.toString() +
                " this.validateAmount(row.amount)=" +
                this.validateAmount(row.amount).toString()
            );

            this.$vs.notify({
              time: 4000 + errorCount * 300,
              color: "danger",
              title: "مبلغ نامعتبر",
              text: `مبلغ ردیف ${i + 1} صحیح نمی باشد.`,
            });
          }
          if (errorCount > 10) break;
          mobileList.push(row.mobile);
        }
        //end validate data ++++++++++++++++

        if (errorCount > 0) {
          await loading;
          this.$vs.loading.close();
          return;
        }
        this.$http
          .post("api/services/app/Bills/CheckAccount", mobileList , {headers: headers})
          .then(async (response) => {
            response.data.result
              .filter((x) => {
                return x.isBlocked; // || x.isMerchant;
              })
              .forEach((x) => {
                let item = this.tableData.find((y) => {
                  return y.mobile.replace(/ /g, "") == x.mobile;
                });
                if (item != undefined) {
                  item.isBlocked = true;
                }
                errorCount += 1;
                if (errorCount < 10) {
                  if (x.isBlocked) {
                    this.$vs.notify({
                      time: 4000 + errorCount * 300,
                      color: "danger",
                      title: "شماره مسدود",
                      text: `شماره ${x.mobile} برای شما مسدود می‌باشد و از لیست قبوض حذف می‌شود.`,
                    });

                    this.$Sentry.captureException(
                      "شماره مسدود" +
                        `شماره ${x.mobile} برای شما مسدود می‌باشد و از لیست قبوض حذف می‌شود.`
                    );
                  }

                  // if (x.isMerchant) {
                  //   this.$vs.notify({
                  //     time: 4000 + errorCount * 300,
                  //     color: "danger",
                  //     title: "شماره غیرمجاز",
                  //     text: `شماره ${x.mobile} پذیرنده است.
                  //     <br/>
                  //     امکان ارسال قبض برای پذیرنده وجود ندارد.`
                  //   });
                  // }
                }
              });

            this.allowedList = response.data.result.filter((x) => {
              return !x.isBlocked; // && !x.isMerchant;
            });

            //add amount, name and descriptions
            this.allowedList.forEach((x) => {
              let item = this.tableData.find((y) => {
                return y.mobile.replace(/ /g, "") == x.mobile;
              });
              if (item != undefined) {
                x.amount = item.amount.replace(/,/g, "");
                x.contactName = item.name;
                let description = {};
                for (let i = 0; i < this.descriptionHeaders.length; i++) {
                  let x = this.descriptionHeaders[i];
                  description[x] = item[x];
                }
                x.merchantDescription = JSON.stringify(description);
              }
            });

            if (this.allowedList.length > 0) {
              this.step = this.Step.Save;
            } else {
              this.$vs.notify({
                time: 4000 + errorCount * 300,
                color: "danger",
                title: "لیست خالی",
                text: `شماره مجازی جهت ساخت قبض وجود ندارد.`,
              });

              this.$Sentry.captureException(
                "لیست خالی" + `شماره مجازی جهت ساخت قبض وجود ندارد.`
              );
            }
            this.checkedAllowedListFromServer = true;
            await loading;
            this.$vs.loading.close();
          }) //end success
          .catch(async (error) => {
            await loading;
            this.$vs.loading.close();
          }); //end http
      } catch {
        await loading;
        this.$vs.loading.close();
      }
    },
    goToEditItemsStep() {
      this.step = this.Step.EditItems;
    },
    save() {
      const selectedAccount = this.$store.getters["account/default"];
      if (!selectedAccount) {
        this.$helper.selectAccount();
        return;
      }
      const headers = {
        AccountId: selectedAccount.id,
      };
      let loading = this.$vs.loading();
      const payload = {
        title: this.title,
        description: this.description,
        accounts: this.allowedList,
      };
      this.$http
        .post("api/services/app/Bills/CreateBill", payload , {headers: headers})
        .then(async (response) => {
          if (response.data.result) {
            this.step = this.Step.Saved;
            this.$vs.notify({
              time: 6000,
              color: "success",
              title: "موفق",
              text: `تعداد ${this.allowedList.length} قبض ایجاد شده است.`,
            });
          } else {
            this.$vs.notify({
              time: 6000,
              color: "danger",
              title: "ناموفق",
              text: `ثبت قبوض با شکست مواجه شد.`,
            });

            this.$Sentry.captureException(
              "ناموفق" + `ثبت قبوض با شکست مواجه شد.`
            );
          }
          await loading;
          this.$vs.loading.close();
        }) //end success
        .catch(async (error) => {
          await loading;
          this.$vs.loading.close();
          this.$vs.notify({
            time: 6000,
            color: "danger",
            title: "ناموفق",
            text: `ثبت قبوض با خطا مواجه شد.`,
          });
          this.$Sentry.captureException("ناموفق" + `ثبت قبوض با خطا مواجه شد.`);
        });
      //end http
    },
    editAmount() {
      this.tableData.forEach((item) => {
        item.amount = this.sourceAmount;
      });
    },
    refreshPage() {
      this.tableData = [];
      this.allowedList = [];
      this.paginationPageSize = 10;
      this.step = Step.EditItems;
      this.title = "";
      this.description = "";
    },
  },
};
</script>
